"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTOCOMPLETE = void 0;
exports.AUTOCOMPLETE = {
    CURRENT_PASSWORD: 'current-password',
    NEW_PASSWORD: 'new-password',
    USERNAME: 'username'
};
//# sourceMappingURL=AUTOCOMPLETE.js.map